import { render } from "./MyAccount.vue?vue&type=template&id=6b80e4d4&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=6b80e4d4&lang=scss"
import "./MyAccount.vue?vue&type=style&index=1&id=6b80e4d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b80e4d4"]])

export default __exports__